import { Routes } from '@angular/router';
import { LoginComponent } from './modules/login/login.component';
import { AuthGuardLogin } from './guards/auth.guard';
import { ForgotPasswordComponent } from './modules/forgot-password/forgot-password.component';
import { FuseFlowComponent } from './modules/fuse-flow/fuse-flow.component';
import { ResetPasswordComponent } from './modules/reset-password/reset-password.component';
import { MfaComponent } from './modules/mfa/mfa.component';
import { LogoutComponent } from './modules/logout/logout.component';
export const routes: Routes = [
	{
		path: '',
		redirectTo: 'login',
		pathMatch: 'full'
		// canActivate: [AuthGuardLogin]
	},
	{
		path: 'login',
		component: LoginComponent,
		canActivate: [AuthGuardLogin]
	},
	{
		path: 'logout',
		component: LogoutComponent
	},
	{
		path: 'mfa',
		component: MfaComponent
	},
	{
		path: 'forget-password',
		component: ForgotPasswordComponent
	},
  {
		path: 'reset-password',
		component: ResetPasswordComponent
	},
	{
		path: 'gdc-flow',
		component: FuseFlowComponent
	},
	{
		path: 'home',
		loadChildren: () => import('./modules/i-forms/i-forms.module').then(m => m.IFormsModule) //iForms module starts
	},
	{
		path: '**',
		redirectTo: ''
	}
];
